const getMiniQueryParam = (activeMini, petites = null) => {
  if (!petites.minis) return '';

  const mini = petites.minis.find((m) => m.id === activeMini);
  const petiteFilters = [];

  if (mini.gender_taxons) {
    mini.gender_taxons.forEach((t) => petiteFilters.push(`gender:${t.permalink.split('/')[1].split('-').join('')}`));
  }

  if (mini.age_range_taxons) {
    mini.age_range_taxons.forEach((t) => petiteFilters.push(`agerange:${t.permalink.split('/')[1].split('-').join('')}`));
  }

  return petiteFilters.join(' ');
};

export default getMiniQueryParam;
